import React from 'react'

import { InstagramConnectionWasSuccessfullyReloadedNotification } from 'common/core/components/NotifyBar/InstagramNotifications/InstagramConnectionWasSuccessfullyReloadedNotification'
import { InstagramFollowReplyStopped } from 'common/core/components/NotifyBar/InstagramNotifications/InstagramFollowReplyStopped/InstagramFollowReplyStopped'
import { InstagramReloadPermissionsSomethingWentWrong } from 'common/core/components/NotifyBar/InstagramNotifications/InstagramReloadPermissionsSomethingWentWrong'
import { InstagramWrongPageReloadPermissions } from 'common/core/components/NotifyBar/InstagramNotifications/InstagramWrongPageReloadPermissions'
import { NotificationBarType } from 'common/core/constants/NotificationBarType'

import {
  InstagramFtdmForAlphaUsersStopNotification,
  InstagramNotification,
  InstagramNotificationType,
  InstagramReadyNotification,
  NotificationRemoveType,
} from '../NotifyInterfaces'

export const parseInstagramNotification = (
  notification: InstagramNotification,
): InstagramReadyNotification => {
  switch (notification.message) {
    case InstagramNotificationType.INSTAGRAM_FTDM_FOR_ALPHA_USERS_STOPPED:
      return {
        ...notification,
        type: NotificationBarType.ERROR,
        removeType: NotificationRemoveType.ALWAYS,
        isWithoutReadMore: true,
        customIconName: 'Attention',
        render: () => (
          <InstagramFollowReplyStopped
            notification={notification as InstagramFtdmForAlphaUsersStopNotification}
          />
        ),
      }

    case InstagramNotificationType.INSTAGRAM_PAGE_CONNECTION_WAS_SUCCESSFULLY_RELOADED:
      return {
        ...notification,
        type: NotificationBarType.SUCCESS,
        removeType: NotificationRemoveType.ALWAYS,
        render: InstagramConnectionWasSuccessfullyReloadedNotification,
      }

    case InstagramNotificationType.INSTAGRAM_WRONG_PAGE_TO_RELOAD_PERMISSIONS:
      return {
        ...notification,
        type: NotificationBarType.ERROR,
        removeType: NotificationRemoveType.ALWAYS,
        render: InstagramWrongPageReloadPermissions,
      }

    case InstagramNotificationType.INSTAGRAM_RELOAD_PERMISSIONS_SOMETHING_WENT_WRONG:
      return {
        ...notification,
        type: NotificationBarType.ERROR,
        removeType: NotificationRemoveType.ALWAYS,
        render: InstagramReloadPermissionsSomethingWentWrong,
      }
  }
}
